module.exports = __webpack_public_path__ + "img/642.71048fcc.png";